import { useState } from 'react';
import { ICoursesByWeek } from '../../../graphql/types/queries/course';
import { CourseRow } from './CourseRow';
import { weeksSummary } from './weeksSummary';
import { HoverableCard, ISummary, ListContainer } from '../LastCourses';
import { useLazyQuery, useQuery } from '@apollo/client';
import { GET_HEALTH_COACH_VISIT_SUMMARIES_ALL, GET_PATIENT_BY_ID } from '../../../graphql/queries';
import { IGetHealthCoachVisitSummariesOutput, IGetHealthCoachVisitSummariesInput } from '../../../graphql/types/queries/healthCoaching';
import { IGetProviderPatientByIdOutput, IGetProviderPatientByIdInput } from '../../../graphql/types/queries/patient';
import { Box, Flex, Text } from 'rebass/styled-components';
import PleaseWait from '../../../components/PleaseWait';

export const Weeker = ({ weeks, onSelect, id, showVisits }: {
  weeks: ICoursesByWeek[]; onSelect: (e: ISummary) => void; id: string
  showVisits: () => void
}) => {
  const [loadSummaries, { data: dataSummaries, loading: loadingSummaries }] = useLazyQuery<IGetHealthCoachVisitSummariesOutput, IGetHealthCoachVisitSummariesInput>(GET_HEALTH_COACH_VISIT_SUMMARIES_ALL)
  const { data: dataPatient, loading: loadingPatient, error: errorPatient } = useQuery<IGetProviderPatientByIdOutput, IGetProviderPatientByIdInput>(GET_PATIENT_BY_ID, {
    variables: {
      id
    },
    onCompleted: e => {
      if (e.getProviderPatientById && e.getProviderPatientById.user) {
        loadSummaries({
          variables: {
            userId: e.getProviderPatientById.user
          }
        })
      }
    }
  })
  const [hoveredRow, setHoveredRow] = useState<number | null>(null);
  const summary = weeksSummary(weeks);

  return (
    <ListContainer flexDirection={'column'}>
      {!!loadingPatient || !!loadingSummaries ? (
        <HoverableCard
          mb={3}
          style={{
            border: '1px solid #E2E2E2',
            borderRadius: '20px',
            padding: '8px',
            opacity: 0.7,
            boxShadow: '0px 4px 20px rgb(0 0 0 / 0%)'
          }}
          onMouseEnter={() => { }}
          onMouseLeave={() => { }}>
          <Flex style={{ width: '100%', padding: '12px 12px', minHeight: '70px' }} flexDirection={['column']}>

            <Box marginTop={['8px']} width={['100%']} paddingLeft={[0]} style={{ alignSelf: 'center' }}>
              <PleaseWait />
            </Box>
          </Flex>
        </HoverableCard>
      ) : (
        <HoverableCard
          onClick={() => { showVisits() }}
          mb={3}
          style={{
            border: '1px solid #E2E2E2',
            borderRadius: '20px',
            padding: '8px',
            opacity: !hoveredRow || hoveredRow === -99 ? 1 : 0.7,
            boxShadow: !hoveredRow || hoveredRow === -99 ? '0px 4px 20px rgb(0 0 0 / 10%)' : '0px 4px 20px rgb(0 0 0 / 0%)'
          }}
          onMouseEnter={() => setHoveredRow(-99)}
          onMouseLeave={() => setHoveredRow(null)}>
          <Flex style={{ width: '100%', padding: '12px 12px' }} flexDirection={['column']}>
            <Box style={{ width: '100%', alignSelf: 'center' }}>
              <Text style={{ color: 'rgba(52,79,122,0.8)', fontSize: '16px', fontWeight: 600 }}>{`Visit Summaries ${!dataSummaries || !dataSummaries.healthCoachGetPatientVisitSummaries ? '' : `(${dataSummaries.healthCoachGetPatientVisitSummaries.filter(x => x.courseId === 'AIP').length})`}`}</Text>
            </Box>
          </Flex>
        </HoverableCard>
      )}
      {summary.map(x => {
        return (
          <CourseRow key={x.weekNumber} row={x} setHover={setHoveredRow} hoveredId={hoveredRow} onSelect={onSelect} />
        );
      })}
    </ListContainer>
  );
};
